export default __webpack_public_path__ + "static/media/background-video.48a24dbd.mp4";